/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_Done_TitleInputs */

const en_cook_done_title = /** @type {(inputs: Cook_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy your meal!`)
};

const de_cook_done_title = /** @type {(inputs: Cook_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guten Appetit!`)
};

/**
* | output |
* | --- |
* | "Enjoy your meal!" |
*
* @param {Cook_Done_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_done_title = /** @type {((inputs?: Cook_Done_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_Done_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_done_title(inputs)
	return en_cook_done_title(inputs)
});